import { z } from 'zod';
import { SanityBlockSchema, SanityDocumentSchema } from '../sanity';
import { SEOSchema } from '../shared/SEO';
import { EntityType } from '$lib/sanity/types';

export const JobListingPageSchema = SanityDocumentSchema.extend({
  _type: z.literal(EntityType.JobListingPage),
  content: z.object({
    header: z.string().optional(),
    pageContent: z.array(SanityBlockSchema).optional()
  }),
  seoAttributes: SEOSchema.nullish()
});

export type JobListingPage = z.infer<typeof JobListingPageSchema>;
